module.exports = __webpack_public_path__ + "arrow-down.c014c41f7d9e95ce4d7e.svg";


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/assets/images/icons/arrow-down.svg
// module id = ../../../../../src/assets/images/icons/arrow-down.svg
// module chunks = styles